import { render, staticRenderFns } from "./canTheWheelBeRiggedCard.vue?vue&type=template&id=a5946b44&scoped=true"
import script from "./canTheWheelBeRiggedCard.vue?vue&type=script&lang=js"
export * from "./canTheWheelBeRiggedCard.vue?vue&type=script&lang=js"
import style0 from "./canTheWheelBeRiggedCard.vue?vue&type=style&index=0&id=a5946b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5946b44",
  null
  
)

export default component.exports